<template>
  <div @click="toggleAvatar" :class="[custom]" class="group flex-shrink-0 group rounded-full bg-secondary border-4 border-solid border-white flex items-center justify-center">
    <div v-if="src" class="w-11 h-11 bg-secondary rounded-full overflow-hidden">
      <img :src="src" alt="Socio del grupo" class="object-cover" />
    </div>
    <div v-else class="w-11 h-11 flex items-center justify-center">
      <span class="block font-bold text-xl text-white">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseListAvatar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Array],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: false
    },
    src: {
      type: String,
      required: false
    }
  },
  data: function () {
    return {}
  },
  computed: {},
  methods: {
    toggleAvatar: function () {
      this.$emit('toggleAvatar')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
